import { FC } from "react";

import { hasKeys } from "@ryde/shared";

import { ErrorsDisplayContainerStyled } from "./errors-display.container.styled";
import { ErrorsDisplayFormsContainer } from "./errors-display.forms.container";
import { IErrorsDisplayContainer } from "./errors-display.models";
import { ErrorsDisplayServerContainer } from "./errors-display.server.container";

export const ErrorsDisplayContainer: FC<IErrorsDisplayContainer> = ({
  serverErrors,
  formErrors,
  marginLeft,
}) => {
  const hasServerErrors = !!serverErrors?.length;
  const hasFormErrors = hasKeys(formErrors);
  const hasErrors = hasServerErrors || hasFormErrors;

  return (
    hasErrors && (
      <ErrorsDisplayContainerStyled
        $marginLeft={marginLeft}
        className="errors-display-container"
      >
        <ErrorsDisplayServerContainer serverErrors={serverErrors} />
        <ErrorsDisplayFormsContainer formErrors={formErrors} />
      </ErrorsDisplayContainerStyled>
    )
  );
};
